export default "__VITE_ASSET__SVU_IohN__"